import React from 'react';

import {
    Footer,
    Meta
} from '$partials/global/index.js';

import ModuleDispatcher from '$partials/modules/dispatcher.jsx';
import LandingPageHero from './landing-page-hero';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').LandingPage}
 */

const LandingPage = ({ data, domain }) => {

    const page = data?.page;

    if (!page) { return null; }

    return (
        <>
            <Meta page={page} />

            <main id='main-content'>
                <div className='min-h-screen'>

                    <h1
                        className='sr-only'
                        dangerouslySetInnerHTML={{ __html: page?.animatedHeroText?.json?.content?.map((block) => block.content.map((node) => node.value).join('')).join('') }}/>

                    <LandingPageHero
                        bodyCopy={page?.bodyCopy}
                        cta1Label={page?.cta1Label}
                        cta1Link={page?.cta1Link}
                        cta2Label={page?.cta2Label}
                        cta2Link={page?.cta2Link}
                        eyebrow={page?.eyebrow}
                        heroMedia={page?.media}
                        heroSimple={page?.heroSimple}
                        heroText={page?.animatedHeroText}
                        pageTitle={page?.pageTitle}
                        polyline={page?.polyline} />

                    {/* Content */}
                    {(page?.modules?.items?.length > 0) && (
                        page.modules.items.map((module, i) => {
                            if (!module) { return null; }
                            return (
                                <ModuleDispatcher
                                    key={i}
                                    module={module}
                                    previousTypename={page.modules.items[i - 1]?.__typename ?? null}
                                    nextTypename={page.modules.items[i + 1]?.__typename ?? null}/>
                            );
                        })
                    )}

                    <div className='pt-8'>
                        <Footer
                            domain={domain}
                            menu={data?.footer} />
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default LandingPage;
